<template>
  <button
    @click.once="handleClick"
    :disabled="loadingState"
    :key="buttonKey"
    type="button"
  >
    <slot>Button </slot>
  </button>
</template>
<script>
export default {
  inheritAttrs: false,
  data: () => ({
    isLoading: false,
    buttonKey: 1
  }),
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingState() {
      return this.loading || this.isLoading;
    }
  },
  methods: {
    async handleClick(e) {
      try {
        this.isLoading = true;
        await this.$listeners.click(e);
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    loadingState() {
      if (!this.loadingState) {
        this.buttonKey++;
      }
    }
  }
};
</script>
<style></style>
